import React from 'react';
import { Textarea as BaseUITextarea } from 'baseui/textarea';
import _isFunction from 'lodash/isFunction';

interface ITextarea {
	value?: any;
	onChange: (event: any) => void;
	overrides?: any;
	onChangeCallback?: any;
}

const Textarea: React.FC<ITextarea> = (props) => {
	const { onChangeCallback, onChange } = props;
	const handleOnChange = (event: any) => {
		onChange(event);
		if (_isFunction(onChangeCallback)) {
			onChangeCallback(props);
		}
	};
	return <BaseUITextarea {...props} onChange={handleOnChange} />;
};

export default Textarea;
